import { isReactFirst } from '~/utils/environment.utils';
import { useInjector } from '~/common/useInjector';
import { IFlowService } from '~/types/angular.types';

export function useAngularFlowService(): IFlowService | null {
    const { FlowService } = useInjector(['FlowService']);
    return isReactFirst() ? null : FlowService;
}
